module.exports = __webpack_public_path__ + "img/88bc805.jpg";